import React from 'react';
import Card from '../../ui/Card';
const RevenueMapChart: React.FC = () => {
  const regionData = [{
    region: 'North',
    revenue: 2850,
    color: 'bg-blue-500'
  }, {
    region: 'West',
    revenue: 3200,
    color: 'bg-blue-600'
  }, {
    region: 'South',
    revenue: 2100,
    color: 'bg-blue-400'
  }, {
    region: 'East',
    revenue: 1100,
    color: 'bg-blue-300'
  }];
  return <Card className="p-6" data-id="element-9065">
      <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-9066">
        Revenue by Region
      </h3>
      <div className="relative h-80 bg-gray-50 rounded-lg flex items-center justify-center" data-id="element-9067">
        {/* Simplified India map representation */}
        <div className="grid grid-cols-2 gap-4 w-full max-w-md" data-id="element-9068">
          {regionData.map(region => <div key={region.region} className="p-6 bg-white border-2 border-gray-200 rounded-lg hover:shadow-lg transition-shadow" data-id="element-9069">
              <div className="flex items-center mb-2" data-id="element-9070">
                <div className={`w-4 h-4 rounded ${region.color} mr-2`} data-id="element-9071" />
                <span className="font-medium text-gray-700" data-id="element-9072">
                  {region.region}
                </span>
              </div>
              <div className="text-2xl font-bold text-gray-800" data-id="element-9073">
                ₹{region.revenue} Cr
              </div>
              <div className="text-sm text-gray-500 mt-1" data-id="element-9074">
                {(region.revenue / 9250 * 100).toFixed(1)}% of total
              </div>
            </div>)}
        </div>
      </div>
    </Card>;
};
export default RevenueMapChart;